import { render } from "./CircularButton.vue?vue&type=template&id=d8042dfa&scoped=true"
import script from "./CircularButton.vue?vue&type=script&lang=js"
export * from "./CircularButton.vue?vue&type=script&lang=js"

import "./CircularButton.vue?vue&type=style&index=0&id=d8042dfa&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8042dfa"]])

export default __exports__